"use client";

import { usePostHog } from "posthog-js/react";

import { PAYPAL_FEATURE_FLAG_NAME } from "./constants";

/** Returns whether the PayPal Express Checkout button should be shown to
 * the currently-identified user, based on the `paypal-express-checkout`
 * PostHog flag.
 *
 * The audience (general rollout vs. KatKin-staff-only "private" rollout)
 * is configured server-side on the PostHog dashboard — by the time this
 * hook runs, the user has already been `posthog.identify(...)`-ed during
 * the user-details step, so PostHog returns the right `true`/`false` for
 * this individual.
 *
 * Fail-closed semantics: anything other than an explicit `true` (flag off,
 * flag still loading, PostHog provider not mounted) collapses to `false`.
 * Better to miss showing the button for a moment than to flash it to a
 * user the dashboard has excluded. */
export function useIsPayPalEnabled(): boolean {
  const posthog = usePostHog();
  return posthog?.isFeatureEnabled(PAYPAL_FEATURE_FLAG_NAME) === true;
}
